import {
  FETCH_JWT_DATA,
  FETCH_JWT_DATA_ERROR,
  FETCH_JWT_DATA_LOADING,
  JWT_EXPIRED_OR_INVALID
} from "../constants";

export function jwtHasErrored(state = false, action) {
  switch (action.type) {
    case FETCH_JWT_DATA_ERROR:
      return action.hasErrored;

    default:
      return state;
  }
}

export function jwtIsLoading(state = false, action) {
  switch (action.type) {
    case FETCH_JWT_DATA_LOADING:
      return action.isLoading;
    default:
      return state;
  }
}

export function jwtExpiredOrInvalid(state = false, action) {
  switch (action.type) {
    case JWT_EXPIRED_OR_INVALID:
      return action.jwtError;
    default:
      return state;
  }
}

export function jwt(state = {}, action) {
  switch (action.type) {
    case FETCH_JWT_DATA:
      return {
        jwt_token: action.jwt.jwt_token,
        refresh_token: action.jwt.refresh_token
      };
    // TODO: RIVEDERE LA DIFFERENZA
    // if (isValidObject(action.jwt)) {
    //     sessionStorage.setItem('jwt', action.jwt.token)
    //     return action.jwt.token
    // } else {
    //     sessionStorage.setItem('jwt', action.jwt)
    //     return action.jwt
    // }

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/JWTReducers.js